import { Card } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { TagManagmentHeader } from "./TagManagmentHeader";
import { TagManagementTable } from "./TagManagementTable";
import { getCategories } from "../../../config/apisauce";
import { INITIAL_GET_PARAMS } from "../../../enums/generalEnums";
import useStore from "../../../states/store";

export const TagManagementCard = (props) => {
  const {
    fetchTypes,
    title,
    defaultCategoryType
  } = props;

  const [, { openLoader, closeLoader }] = useStore();
  const [category, setCategory] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [pagination, setPagination] = useState({ pageSize: 5, page: 0 });
  const [openAddDialog, setOpenAddDialog] = useState(false);

  const handleSelectCategory = (data) => {
    setSelectedCategory(data);
    setOpenAddDialog(true);
  };

  const fetchCategories = async () => {
    openLoader();
    const params = {
      ...INITIAL_GET_PARAMS,
      type: fetchTypes,
      pagination: true,
      per_page: pagination?.pageSize,
      page: pagination?.page + 1
    };
    const response = await getCategories(params);
    if (response.ok) {
      setCategory(response?.data);
    };
    closeLoader();
  };

  useEffect(() => {
    fetchCategories();
  }, [pagination]);

  return (
    <Fragment>
      <Card>
        <TagManagmentHeader
          title={title}
          subTitle={<>View and manage all the listed <b>{title}.</b></>}
          selectedCategory={selectedCategory}
          alterList={setCategory}
          openAddDialog={openAddDialog}
          setOpenAddDialog={setOpenAddDialog}
          setSelectedCategory={setSelectedCategory}
          type={defaultCategoryType}
        />
        <TagManagementTable
          title={title}
          requestData={category}
          setPagination={setPagination}
          isEditable={true}
          handleOpenDialog={(params) => handleSelectCategory(params)}
          alterList={setCategory}
          type={defaultCategoryType}
        />
      </Card>
    </Fragment>
  );
};